import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class ProgramarService {
  constructor(private http: HttpClient) {}

  public get(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/settings/unidades/get`
    );
  }
  public getByIdRecepcion(id: string): Observable<any> {
    return this.http.get<any>(
      `${environment.serverUrl}api/settings/mantenimiento/getByIdRecepcion`,
      { params: { id } }
    );
  }
  public getPending(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/settings/mantenimiento/getPending`
    );
  }
  public getByUnidad(id: string): Observable<any[]> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: { id },
    };
    return this.http.get<any[]>(
      `${environment.serverUrl}api/settings/mantenimiento/getByUnidad`,
      options
    );
  }
  public crear(detalles: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/settings/mantenimiento/crear`,
      detalles,
      options
    );
  }
  public addDetalle(detalles: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/settings/mantenimiento/addDetalle`,
      detalles,
      options
    );
  }
  public addRefaccion(detalles: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/settings/mantenimiento/addRefaccion`,
      detalles,
      options
    );
  }
  public addRecepcion(
    datos: any,
    files: File[],
    firmaChofer: File,
    firmaSupervisor: File,
    licencia: File
  ): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append("IdMantenimiento", String(datos.IdMantenimiento));
    formData.append("IdChofer", String(datos.IdChofer));
    formData.append("IdSupervisor", String(datos.IdSupervisor));
    formData.append("IdUnidad", String(datos.IdUnidad));
    formData.append("Kilometraje", String(datos.Kilometraje));
    formData.append("PolizaBool", String(datos.PolizaBool));
    formData.append("PolizaVigencia", String(datos.PolizaVigencia));
    formData.append("TanqueGas", String(datos.TanqueGas));
    formData.append("Llantas", String(datos.Llantas));
    formData.append("Golpes", String(datos.Golpes));
    formData.append(
      "TarjetaCirculacionBool",
      String(datos.TarjetaCirculacionBool)
    );
    formData.append(
      "TarjetaCirculacionVigencia",
      String(datos.TarjetaCirculacionVigencia)
    );

    formData.append(
      "Funcionamientos",
      String(JSON.stringify(datos.Funcionamientos))
    );
    formData.append(
      "Observaciones",
      String(JSON.stringify(datos.Observaciones))
    );

    files.forEach((file) => {
      formData.append(file.name, file, file.name);
    });

    if (firmaChofer) {
      formData.append("firmachofer", firmaChofer, "firmachofer");
    }
    if (firmaSupervisor) {
      formData.append("firmaSupervisor", firmaSupervisor, "firmaSupervisor");
    }
    if (licencia) {
      formData.append("licencia", licencia, "licencia");
    }

    const uploadReq = new HttpRequest(
      "POST",
      `${environment.serverUrl}api/settings/mantenimiento/addRecepcion`,
      formData
    );
    return this.http.request<any>(uploadReq);
  }
  public terminar(prefinish: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/settings/mantenimiento/terminar`,
      prefinish,
      options
    );
  }

  public cancelar(i: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: { i },
    };
    return this.http.get<any>(
      `${environment.serverUrl}api/settings/mantenimiento/cancelar`,
      options
    );
  }

  public reprogramar(detalles: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/settings/mantenimiento/reprogramar`,
      detalles,
      options
    );
  }

  public addPhotoDet(asm: string, foto: File): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append("asm", String(asm));
    if (foto) {
      formData.append("foto", foto, "foto");
    }

    const uploadReq = new HttpRequest(
      "POST",
      `${environment.serverUrl}api/settings/mantenimiento/addPhotoDet`,
      formData
    );
    return this.http.request<any>(uploadReq);
  }
  public addPhotoRef(asm: string, foto: File): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append("asm", String(asm));
    if (foto) {
      formData.append("foto", foto, "foto");
    }

    const uploadReq = new HttpRequest(
      "POST",
      `${environment.serverUrl}api/settings/mantenimiento/addPhotoRef`,
      formData
    );
    return this.http.request<any>(uploadReq);
  }
  public prestart(IdUnidad: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: { i: IdUnidad },
    };
    return this.http.get<any>(
      `${environment.serverUrl}api/settings/mantenimiento/prestart`,
      options
    );
  }

  public inicarConRecepcion(
    IdMantenimiento: string,
    IdRecepcion: string
  ): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/settings/mantenimiento/startwid`,
      { IdMantenimiento, IdRecepcion },
      options
    );
  }

  public prefinish(IdMantenimiento: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: { i: IdMantenimiento },
    };
    return this.http.get<any>(
      `${environment.serverUrl}api/settings/mantenimiento/prefinish`,
      options
    );
  }
  public getResume(i: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: { i },
    };
    return this.http.get<any>(
      `${environment.serverUrl}api/settings/mantenimiento/getResume`,
      options
    );
  }
}
